import { pluginSettingsVar } from './apollo/store';
import { ProductType } from 'gql/__generated/vp-apollo';
import { AppDocsis } from './AppDocsis';
import { AppFttx } from './AppFttx';

export const Fork = () => {
    const { productType = null } = pluginSettingsVar();
    return productType === ProductType.Fttx ? <AppFttx /> : <AppDocsis />;
};
